import {Row, Col} from "react-bootstrap"
import React, {Component, Fragment} from "react"
import {connect} from "react-redux"
import styled from "styled-components"

import Hr from "@irati/ui/src/Layout/Hr"
import {H1} from "@irati/ui/src/Typography"
import {SmallCaption} from "@irati/ui/src/Labels"
import Loading from "@irati/ui/src/Loading"
import Card from "@irati/ui/src/Layout/Card"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import savedCardsEmpty from "@irati/ui/images/saved-cards-empty.png"
import {getSavedCards, deleteSavedCard} from "@irati/payments/services/SavedCards"
import {User} from "@irati/types"

import UserSavedPaymentCard from "../../components/UserSavedPaymentCard/UserSavedPaymentCard"
import EmptyState from "../../components/EmptyState/EmptyState"

const RightCol = styled(Col)`
  text-align: right;
`

interface Props extends InjectIntl {
  user: User
}
interface State {
  savedCards: Card[] | [],
  load: Promise<void>
}

class UpdateUserPaymentContainer extends Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      savedCards: [],
      load: getSavedCards().then(({results}) => {
        this.setState({savedCards: results})
      })
    }
  }

  removePaymentMethod = (card: typeof Card) => {
    deleteSavedCard(card).then(() => {
      this.setState((state) => ({
        savedCards: state.savedCards.filter((savedCard) => savedCard.reference !== card.reference)
      }))
    })
  }

  render() {
    const {formatMessage} = this.props
    const {savedCards, load} = this.state

    return (
      <Card tiny noBorder>
        <H1 marginBottom={4}>
          <FormattedMessage id="account.payment.header" />
        </H1>
        <Loading load={load}>
          {savedCards.length > 0 && (
            <div>
              <Row>
                <Col xs={3}>
                  <SmallCaption uppercase>
                    <FormattedMessage id="account.payment.headers.cardType" />
                  </SmallCaption>
                </Col>
                <Col xs={3}>
                  <SmallCaption uppercase>
                    <FormattedMessage id="account.payment.headers.cardName" />
                  </SmallCaption>
                </Col>
                <RightCol xs={2}>
                  <SmallCaption uppercase>
                    <FormattedMessage id="account.payment.headers.cardNumber" />
                  </SmallCaption>
                </RightCol>
                <RightCol xs={2}>
                  <SmallCaption uppercase>
                    <FormattedMessage id="account.payment.headers.cardExpDate" />
                  </SmallCaption>
                </RightCol>
              </Row>
              <Hr marginTop={1} />
              {savedCards.map((card) => (
                <Fragment key={card.reference}>
                  <UserSavedPaymentCard removePaymentMethod={() => this.removePaymentMethod(card)} {...card} />
                  <Hr />
                </Fragment>
              ))}
            </div>
          )}
          {savedCards.length === 0 && (
            <EmptyState
              description={formatMessage({id: "account.payment.empty"})}
              src={savedCardsEmpty}
              alt={formatMessage({id: "account.payment.alt"})} />
          )}
        </Loading>
      </Card>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user
  }
}

const UpdateUserPayment = connect(mapStateToProps)(UpdateUserPaymentContainer)

export default injectIntl(UpdateUserPayment)
